import { getDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

// Important! : Make sure you work with lower case mail at all times

export async function addUser(email, firstName, lastName, phoneNumber, city, street, houseNumber) {
    email = email.toLowerCase()
    const docRef = await setDoc(doc(db, "user_details", email), {
        email: email,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
        city: city,
        street: street,
        house_number: houseNumber
    });
    console.log("UserDocument added with email: ", email);
    return docRef;
}

export async function updateUser(email, detailsArr) {
    // details arr = [firstName, lastName, phoneNumber, city, street, houseNumber]
    email = email.toLowerCase()
    const docRef = doc(db, 'user_details', email);
    await setDoc(docRef, {
        email: email,
        first_name: detailsArr[0],
        last_name: detailsArr[1],
        phone_number: detailsArr[2],
        city: detailsArr[3],
        street: detailsArr[4],
        house_number: detailsArr[5]
    });
    console.log(`user with email ${email} was created/updated`)
}

export async function getUserData(email){
    email = email.toLowerCase()
    console.log(`Fetching user data from DB for ${email}...`)
    const docRef = doc(db, 'user_details', email);
    const docSnap = await getDoc(docRef);
    const userData = docSnap.data();
    console.log(`successfully retrieved ${email} user data from DB`);//: phone - ${userData.phone_number}, address - ${userData.address}`);
    return userData;
}
